function filterVariations(variationData) {
    let variantString = '';

    variationData.forEach((variation, idx, array) => {
        if (Object.keys(variation.values).length) {
            variantString = `${variantString + variation.attributeId}:`;

            variation.values.forEach((value) => {
                if (value.selected) {
                    variantString += value.value;
                }
            });

            if (idx !== array.length - 1) {
                variantString += '/';
            }
        }
    });

    return variantString;
}

function getList(element) {
    const typeViewOfGrid = $('#datalayerKindList').data('list');
    let listName;

    if (typeViewOfGrid === 'search' || typeViewOfGrid === 'category') {
        const searchInfo = $('#searchInfo').data('search');

        if (searchInfo === '') {
            listName = `Resultados de Categoria ${element
                .find('.gtmProdCategory')
                .data('pinfo')}`;
        } else {
            listName = `Resultados de busqueda: ${searchInfo}`;
        }
    } else if (typeViewOfGrid === 'home') {
        listName = 'Productos de portada';
    } else if (typeViewOfGrid === 'prodView') {
        listName = 'Ficha de producto';
    } else if (typeViewOfGrid === 'cart') {
        listName = 'Productos en pagina del carrito';
    }

    return listName;
}

const validateElement = elem => (elem === null || elem === undefined ? '' : elem);

const productClickStructure = element => ({
    name: $(element).find('.pdp-link > a')[0].innerText,
    id: validateElement($(element).data('pid')),
    price: validateElement($(element)
        .find('.gtmProdPrice')
        .data('pinfo'))
        .toString(),
    brand: validateElement($(element)
        .find('.gtmProdBrand')
        .data('pinfo')),
    category: validateElement($(element)
        .find('.gtmProdCategory')
        .data('pinfo')),
    variant: validateElement(JSON.parse(element.find('.gtmProdVariations').attr('data-pinfo')))
        ? filterVariations(JSON.parse(element.find('.gtmProdVariations').attr('data-pinfo')))
        : '',
    position: $(element).parent().index() + 1,
});

module.exports = {
    getList,
    productClickStructure,
    filterVariations,
};
